'use strict';

(function () {
  'use strict';

  angular.module('msActivities').directive('msFavoriteButton', msFavoriteButton);

  msFavoriteButton.$inject = [];

  function msFavoriteButton() {
    var directive = {
      bindToController: true,
      controller: ['librarySvc', 'eventTrackingSvc', FavoriteButtonCtrl],
      controllerAs: 'vm',
      restrict: 'AE',
      templateUrl: 'activities/templates/favoriteButton.html',
      scope: {
        activity: '=msFavoriteButton'
      }
    };
    return directive;
  }

  function FavoriteButtonCtrl(librarySvc, eventTrackingSvc) {
    this.$onInit = function () {
      var vm = this;

      librarySvc.inLibrary(vm.activity.url).then(function (inLibrary) {
        vm.inLibrary = inLibrary;
      });
      vm.toggle = function () {
        eventTrackingSvc.fireEvent('activity', 'toggleLibrary', vm.inLibrary ? 'remove' : 'add', { activity: vm.activity.url, action: vm.inLibrary ? 'remove' : 'add' });
        librarySvc.toggleLibrary(vm.activity.id, vm.inLibrary).then(function () {
          vm.inLibrary = !vm.inLibrary;
        });
      };
    };
  }
})();